import { FETCH_DEALER_SUCCESS } from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

/** @typedef {Object<string, import('../../types').ConfigGeneral>} State */

/** @type {State} */
const initialState = {};

/**
 * @param {State} state
 * @param {import('../../types').FetchGeneralSuccessAction|import('../../types').PutGeneralSuccessAction} action
 * @returns {State}
 */
const update = (state, { payload }) => ({
  ...state,
  [payload.dealerId]: {
    ...(state[payload.dealerId] ?? {}),
    ...payload.config,
  },
});

export default createReducer(
  initialState,
  {
    [types.FETCH_SUCCESS]: update,
    [types.PUT_SUCCESS]: update,
    [types.POST_SUCCESS]: update,
  },
  [
    {
      matcher: ({ type, payload: dealer }) => type === FETCH_DEALER_SUCCESS && dealer.projectionType === 'details',
      reducer: (state, { payload }) => ({
        ...state,
        [payload.id]: {
          ...(state[payload.id] ?? {}),
          ...payload.config.general,
        },
      }),
    },
  ]
);
